import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PublicOnly() {
    const { username, privateKey, isLoggingOut } = useAuth();

    // Don't redirect while logging out
    if (isLoggingOut) {
        return <Outlet />;
    }

    // Only redirect if FULLY authenticated (has both session AND decrypted key)
    // If user has session but no key, let them view public pages normally
    if (username && privateKey) {
        return <Navigate to="/account" replace />;
    }

    return <Outlet />;
}
